"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInfo = exports.hidePlayerData = void 0;
var vue_1 = require("vue");
var PlayerResources_1 = require("./PlayerResources");
var PlayerTags_1 = require("./PlayerTags");
var PlayerStatus_1 = require("./PlayerStatus");
var utils_1 = require("../../utils/utils");
var utils_2 = require("../../utils/utils");
var PlayerMixin_1 = require("../PlayerMixin");
var isPinned = function (root, playerIndex) {
    return root.getVisibilityState('pinned_player_' + playerIndex);
};
var showPlayerData = function (root, playerIndex) {
    root.setVisibilityState('pinned_player_' + playerIndex, true);
};
var hidePlayerData = function (root, playerIndex) {
    root.setVisibilityState('pinned_player_' + playerIndex, false);
};
exports.hidePlayerData = hidePlayerData;
exports.PlayerInfo = vue_1.default.component('player-info', {
    props: {
        player: {
            type: Object,
        },
        activePlayer: {
            type: Object,
        },
        firstForGen: {
            type: Boolean,
        },
        actionLabel: {
            type: String,
        },
        playerIndex: {
            type: Number,
        },
        hideZeroTags: {
            type: Boolean,
        },
    },
    components: {
        'player-resources': PlayerResources_1.PlayerResources,
        'player-tags': PlayerTags_1.PlayerTags,
        'player-status': PlayerStatus_1.PlayerStatus,
    },
    mixins: [PlayerMixin_1.PlayerMixin],
    methods: {
        getClasses: function () {
            var classes = ['player-info'];
            classes.push(utils_1.playerColorClass(this.player.color, 'bg_transparent'));
            return classes.join(' ');
        },
        getPlayerStatusAndResClasses: function () {
            var classes = ['player-status-and-res'];
            return classes.join(' ');
        },
        getIsActivePlayer: function () {
            return this.player.color === this.activePlayer.color;
        },
        pinPlayer: function () {
            var _this = this;
            var hiddenPlayersIndexes = [];
            var playerPinned = isPinned(this.$root, this.playerIndex);
            hiddenPlayersIndexes = utils_2.range(this.activePlayer.players.length - 1);
            if (!playerPinned) {
                showPlayerData(this.$root, this.playerIndex);
                hiddenPlayersIndexes = hiddenPlayersIndexes.filter(function (index) { return index !== _this.playerIndex; });
            }
            for (var i = 0; i < hiddenPlayersIndexes.length; i++) {
                if (hiddenPlayersIndexes.includes(i)) {
                    exports.hidePlayerData(this.$root, i);
                }
            }
        },
        buttonLabel: function () {
            return isPinned(this.$root, this.playerIndex) ? 'hide' : 'show';
        },
        togglePlayerDetails: function () {
            if (this.player.color === this.activePlayer.color) {
                var el = document.getElementsByClassName('sidebar_icon--cards')[0];
                el.click();
                return;
            }
            this.pinPlayer();
        },
        getNrPlayedCards: function () {
            return this.player.playedCards.length;
        },
        getAvailableBlueActionCount: function () {
            return this.player.availableBlueCardActionCount;
        },
    },
    template: "\n      <div :class=\"getClasses()\">\n        <div :class=\"getPlayerStatusAndResClasses()\">\n        <div class=\"player-status\">\n          <div class=\"player-info-details\">\n            <div class=\"player-info-name\">{{ player.name }}</div>\n            <div class=\"icon-first-player\" v-if=\"firstForGen && activePlayer.players.length > 1\">1st</div>\n            <div class=\"player-info-corp\" v-if=\"player.corporationCard !== undefined\" :title=\"player.corporationCard.name\">{{ player.corporationCard.name }}</div>\n          </div>\n          <player-status :player=\"player\" :activePlayer=\"activePlayer\" :firstForGen=\"firstForGen\" v-trim-whitespace :actionLabel=\"actionLabel\" :playerIndex=\"playerIndex\"/>\n        </div>\n          <player-resources :player=\"player\" v-trim-whitespace />\n          <div class=\"player-played-cards\">\n            <div class=\"player-played-cards-top\">\n              <div class=\"played-cards-elements\">\n                <div class=\"played-cards-icon hiding-card-button active\"></div>\n                <div class=\"played-cards-icon hiding-card-button automated\"></div>\n                <div class=\"played-cards-icon hiding-card-button event\"></div>\n                <div class=\"played-cards-count\">\n                  {{\n                    getNrPlayedCards()\n                  }}\n                </div>\n              </div>\n            </div>\n            <Button class=\"played-cards-button\" size=\"tiny\" :onClick=\"togglePlayerDetails\" :title=\"buttonLabel()\" />\n          </div>\n          <div class=\"tag-display player-board-blue-action-counter tooltip tooltip-bottom\" data-tooltip=\"The number of available actions on active cards\">\n            <div class=\"tag-count tag-action-card\">\n              <div class=\"blue-stripe\"></div>\n              <div class=\"red-arrow\"></div>\n            </div>\n            <span class=\"tag-count-display\">{{ getAvailableBlueActionCount() }}</span>\n          </div>\n        </div>\n        <player-tags :player=\"player\" v-trim-whitespace :isActivePlayer=\"getIsActivePlayer()\" :hideZeroTags=\"hideZeroTags\" />\n      </div>\n    ",
});
//# sourceMappingURL=PlayerInfo.js.map